import { Component, OnInit } from '@angular/core';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';
import { UserDetailResult, Product } from 'src/app/model/UserDetail';
import { UserModel } from 'src/app/model/UserModel';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { ProductService } from 'src/app/services/product.service';
import { AccountService } from 'src/app/services/account.service';
import { DataServiceService } from 'src/app/services/data-service.service';
import { environment } from 'src/environments/environment';
import { DataUnitofMeasureInfo } from 'src/app/model/selfcareproducts';
import { RenewPlanModel, KeyValuePair } from 'src/app/model/RenewPlan';
import { ProductResult } from 'src/app/model/Product';
import { SubscriberInfo, AccountModel } from 'src/app/model/AccountModel';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-manage-account',
  templateUrl: './manage-account.component.html',
  styleUrls: ['./manage-account.component.css']
})
export class ManageAccountComponent implements OnInit {
  useraccountsdata:  LteActiveSession[]=[];

  initloading: boolean = true;
  userdetail: UserDetailResult;
  firstname: string;
  planname: string;
  planstatus: string;
  activeProducts2: any;
  activeProducts: LteActiveSession[];
  customer: any;
  MDN1: string;
  totalGb: string;
  currentUsage: string;
  daysLeft: string;
  progress: any;
  currentUser: UserModel;
  config: object;
  selectedOptions: any;
  customerBalance: string;
  accType: any;
  renewVisible:boolean = false;
  actionValues :any;



  processing: boolean = false;
  tranSuccess: boolean = false;
  tranFailed: boolean = false;
  pagetitle: string;
 
 
  renewModel: RenewPlanModel = {} as RenewPlanModel;
  period: KeyValuePair[];
  selectedPeriod: number = 0;
  newServicePlanId: number = 0;
  newServicePlan: string;
  newServicePlanPrice: string;
  timeSlot: string;
  speed: string;
  capacity: string;
  validity: string;
  paymentMethod: string;
  selectedPlan: Product = {} as Product;
  filteredselfcareproduct: ProductResult[] = [] as ProductResult[];
  totalAmount: any;
  currentpassword :string;
  newpassword:string;
  confirmpassword:string;

 
  editCache: { [key: string]: any } = {};

  changePwdForm: FormGroup;
  loading = false;
  submitted = false;
  searchText:string;

  filterData:  LteActiveSession[]=[];



  constructor(private toastr: ToastrService, private router: Router, private sharedService: SharedService, private productService: ProductService, 
    private authenticationService: AuthenticationService, private accountService: AccountService, private dataService: DataServiceService, private formBuilder: FormBuilder) {
      this.actionValues = [
        { id: 1, Name: "Change Plan" },
        { id: 2, Name: "Renew Account" },
        { id: 3, Name: "Fund Wallet" }
    ]
      this.currentUser = this.authenticationService.getCurrentUser();

      
    if(this.currentUser.i_Account == "0")
    {
   let KycStatus :string = this.currentUser.KycStatus;

   if(KycStatus)
   {  if(KycStatus.toLowerCase() === "Rejected".toLowerCase() || KycStatus.toLowerCase() === "No Kyc".toLowerCase())
   { 
     this.router.navigate(['/kyc']); 

   }

}
  
 
 
    }

      if (this.currentUser == null) {
        this.router.navigateByUrl("/signin");
        return;
      }
  
      this.firstname = this.currentUser.FirstName;
   
  
      this.dataService.currentAccountType.subscribe(acc => {
        this.accType = acc ;//? acc: true;
        console.log(this.accType);
        this.fetchAccounts();
  
      });



     





     }


     valuechange(newValue) 
     {
      this.searchText = newValue;
    
      
    
  
      if (this.searchText.length==0)
      {
        this.filterData =this.useraccountsdata;
      }
      else
      {
  
        this.filterData = this.useraccountsdata.filter(x => x.AccountName.toLowerCase().includes(this.searchText.toLowerCase()) || x.ID.toLowerCase().includes(this.searchText.toLowerCase()));
       
  
      }
  
      
    }
  

   // convenience getter for easy access to form fields
   get f() { return this.changePwdForm.controls; }
     chanUserPwd()
     {

      for (const i in this.changePwdForm.controls) {
        this.changePwdForm.controls[i].markAsDirty();
        this.changePwdForm.controls[i].updateValueAndValidity();
      }



       this.submitted = true;

       // stop here if form is invalid
       if (this.changePwdForm.invalid) {
           return;
       }


       
       this.loading = true;
       var val:boolean =this. finishFunction();
       this.loading = false;

     }

     finishFunction ():boolean
     {
       var  retVal: boolean  = false;
       var user = this.currentUser;
   
     
       var defaultpassword:boolean=false;
   
       this.accountService.SetPasswordr(user.UserID, this.newpassword, defaultpassword,user.i_Account).subscribe(    
         data => {    
               
           if(data.Status==1)    
           {       
            
             retVal = true;
             this.toastr.info("Password changed succesfully");
         
             
            
           }    
           else{   
          
   
             retVal = false;
             this.toastr.error("error changing password");
           }    
         },     
         error => {    
            
      
         });    
     
       return retVal;
   
   
     }





     async fetchAccounts() {

      var my_object = this.currentUser;
      let activeSessionRequest: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
      activeSessionRequest.DownloadType = "ACC:GetDetail";
  
      if (my_object) {
        var iAccount = parseInt(my_object.i_Account);
  
        if (iAccount == 0)   //  customer with multiple accounts
        {
          //an individual
          activeSessionRequest.i_customer = parseInt(my_object.i_Customer);
          
          await this.setActiveSession(activeSessionRequest);
  
        }
        else  // single account
        {
          activeSessionRequest.i_account = parseInt(my_object.i_Account);
          this.setActiveSession(activeSessionRequest);
          
        }
  
      }
    }
  ngOnInit() {

    this.changePwdForm = this.formBuilder.group({
      currentpassword: [null, [Validators.required]],
      newpassword: [null, [Validators.required]],
      confirmpassword: [null, [Validators.required]]
    
    });


 
  }
  async setActiveSession(model: ActiveSessionsReqObj) {


    if (model) 
    { 
      let res = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
      if (!res.Result) {
        
        this.toastr.error("An error occured, Couldn't get active sessions", "Error");
        return;
      }
      if (this.accType == "VOICE") {
        this.sharedService.activeSessions = <LteActiveSession[]>  res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice"));

        this.useraccountsdata = <LteActiveSession[]>  res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice"));

      } else {
        this.sharedService.activeSessions = <LteActiveSession[]>  res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice"));
        this.useraccountsdata =  <LteActiveSession[]>  res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice"));
        this.filterData = this. useraccountsdata;
    
      }

     
     
     // await this.getAccountDetail(this.activeProducts[0].i_account);

    }

    this.updateEditCache();
  }
  renewAccount(model:LteActiveSession)
  {
   // this.openRenew();
   if(model.block==environment.pausedAccId){
    this.toastr.error("You cannot renew a paused account. Please contact Customer Care");
    return;
  }

      this.router.navigateByUrl('/renewplan?acc=' + model.i_account);
  }

  changePlan(model:LteActiveSession)
  {
    if(model.AccountState==environment.pausedAccId){
      this.toastr.error("You cannot changeplan of a paused account. Please contact Customer Care");
      return;
    }
    this.router.navigateByUrl(`/renewplan?acc=${model.i_account}&changeplan=true`);

  }


  fundwallet() {
    this.router.navigateByUrl('/funddatareserve');
  }

  


  topUpData(model:LteActiveSession)
  {
    if(model.block==environment.pausedAccId){
      this.toastr.error("You cannot top up a paused account. Please contact Customer Care");
      return;
    }
    this.router.navigateByUrl('/topup?acc=' + model.i_account);

  }


  async getAccountDetail(i_account) {

    try {

      let reqObj = {
        i_account: i_account
      }

      let millisecondsInDays = 86400000;
      let today = new Date().getTime();
      var model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
      model.i_account = i_account;
      model.DownloadType = "ACC:GetDetail";

      let userDetailResult = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();

      if (!userDetailResult) {
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }

      this.userdetail = userDetailResult.Result[0];
      this.sharedService.userdetail = userDetailResult.Result[0];

      var userdetail = this.sharedService.userdetail;
      this.planname = userdetail.Product.Name;
      this.setStatus(userdetail.AccountState);

      this.MDN1 = userdetail.AccountName ? userdetail.AccountName : userdetail.ID;
      let voiceproduct = userdetail.Product.Name.toLowerCase().includes("voice");

      if (voiceproduct) {
        this.currentUsage = "₦" + userdetail.Balance.toLocaleString();
      } else {
        this.currentUsage = parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(2) + DataUnitofMeasureInfo[userdetail.Product.Display.DataCapacity.UnitofMeasure];
      }


      let expiryDate = Date.parse(userdetail.ExpirationDate.toString());
      let daysLeft = Math.round((expiryDate - today) / millisecondsInDays);
      this.daysLeft = daysLeft < 0 ? "" : daysLeft + " days left"


      let res = await this.accountService.getCustomerBalance(userdetail.i_customer).toPromise();
      if (res.Result) {
        this.sharedService.CustomerBalance = Math.round(res.Result);
        this.customerBalance = "₦" + this.sharedService.CustomerBalance.toLocaleString();
      }

      this.initloading = false;

    }
    catch (err) {
      this.toastr.error(environment.GenericErrorMsg, "Error");
    }

  }
  setStatus(accountState) {
    switch (accountState) {
      case 0: {
        this.planstatus = "Blocked";
        break;
      }
      case 1: {
        this.planstatus = "Active";
        break;
      }
      case 2: {
        this.planstatus = "ZeroBalance";
        break;
      }
      case 3: {
        this.planstatus = "Expired";
        break;
      }
      default: {

        break;
      }

    }

  }
  requestloan(model:LteActiveSession) {
 

    /*if (!account) {
      return;
    }

    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("request loan is only available on data plans", "Error");
      return;
    }*/
    if(model.block==environment.pausedAccId){
      this.toastr.error("You cannot renew a paused account. Please contact Customer Care");
      return;
    }
    this.router.navigateByUrl('/requestloan?acc=' + model.i_account);

  }
  openRenew() :void
  {
    this.renewVisible = true;

  }
  


  closeRenew(): void {
    this.renewVisible = false;
  }
  startEdit(ID: string): void {
    this.editCache[ID].edit = true;
  }

  cancelEdit(ID: string): void {
    const index = this.useraccountsdata.findIndex(item => item.ID === ID);
    this.editCache[ID] = {
      data: { ...this.useraccountsdata[index] },
      edit: false
    };
  }

  async saveEdit(ID: string)  {
    
    const index = this.useraccountsdata.findIndex(item => item.ID === ID);
    Object.assign(this.useraccountsdata[index], this.editCache[ID].data);
    this.editCache[ID].edit = false;

    // now lets call API to edit susbscriber information
     
    

   
  var activeSession: LteActiveSession = this.useraccountsdata[index];
     
    var subscriberinfo : SubscriberInfo = {} as SubscriberInfo;
    var accountModel:AccountModel ={} as AccountModel;
    subscriberinfo.FirstName =  activeSession.AccountName;
    var IAccount:number = activeSession.i_account;


    accountModel.subscriber =  subscriberinfo;
    accountModel.i_account = IAccount;
   
    //var fname:string = accountModel.subscriber.FirstName

       var rest= await this.accountService.updateSuscriber( IAccount , accountModel).toPromise();


       if (rest.Status ===1)
       {
         this.toastr.success("Account name  changed successful");
         this.fetchAccounts();
       }
       console.log(rest);
   



    
  }

  updateEditCache(): void {
    
    this.useraccountsdata.forEach(item => {
      this.editCache[item.ID] = {
        edit: false,
        data: { ...item }
      };
    });
  }
}
